var map = {
	"./Component 58 – 13.svg": 242,
	"./Frame-10.svg": 187,
	"./Frame-11.svg": 247,
	"./Frame-12.svg": 248,
	"./Frame-8.svg": 552,
	"./Frame-9.svg": 553,
	"./GPS.png": 1023,
	"./Group 270.svg": 111,
	"./Group 922.svg": 243,
	"./Group2701.svg": 191,
	"./IXP-Logo_White-.png": 304,
	"./Icon-material-bookmark-border.svg": 330,
	"./Icon-material-bookmark.svg": 331,
	"./Passed.svg": 244,
	"./UGPG.png": 1024,
	"./WiredMobile.png": 106,
	"./add-file.png": 140,
	"./add.svg": 41,
	"./admin-assignment-tick.png": 164,
	"./admin-assignment-tickdisabled.png": 224,
	"./admin.svg": 379,
	"./apple-store-icon.png": 257,
	"./ask-doubts.svg": 1025,
	"./assessment.svg": 108,
	"./assessmentx.svg": 263,
	"./assignment-clock-icon.png": 154,
	"./assignment-listing-arrow.png": 135,
	"./assignment.svg": 61,
	"./attempt.jpeg": 554,
	"./attempt.svg": 1026,
	"./attempt1.svg": 443,
	"./attempted.svg": 122,
	"./attendance-report-absent.svg": 229,
	"./attendance-report-not-viewed.svg": 230,
	"./attendance-report-present.svg": 231,
	"./attendance-report-recording-icon.svg": 518,
	"./attendance-report-video-icon.svg": 363,
	"./attendance-report-viewed-video.svg": 232,
	"./attendance.png": 440,
	"./avg-time.svg": 100,
	"./back.svg": 40,
	"./blog.png": 441,
	"./books.png": 374,
	"./brandlogo.png": 1027,
	"./business-categoryicon.png": 402,
	"./c_assignment.png": 393,
	"./c_audio.png": 1028,
	"./c_live_class.png": 1029,
	"./c_notes.png": 394,
	"./c_quizz.png": 395,
	"./c_scorm.png": 1030,
	"./c_survey.png": 1031,
	"./c_text.png": 1032,
	"./c_video.png": 302,
	"./c_video.svg": 1033,
	"./calendar-icon.svg": 375,
	"./calendar.svg": 134,
	"./calendar2.svg": 44,
	"./category.jpg": 182,
	"./certificatesidebarmenu.png": 437,
	"./challengesidebarmenu.png": 436,
	"./chapter.svg": 531,
	"./check-list.png": 439,
	"./check-symbol.svg": 107,
	"./class.svg": 1034,
	"./classroom.svg": 299,
	"./clock.svg": 332,
	"./code-lab.svg": 555,
	"./coding.svg": 556,
	"./collapse.svg": 130,
	"./comment.svg": 1035,
	"./communitysidebar.png": 438,
	"./contact-us.svg": 409,
	"./content-point.svg": 391,
	"./content.svg": 1036,
	"./correct.svg": 101,
	"./dashboard-icon.png": 1037,
	"./dashboard.svg": 312,
	"./delete.svg": 28,
	"./design-categoryicon.png": 401,
	"./difficulty-meter.svg": 102,
	"./dots.png": 1038,
	"./doubt-image.svg": 83,
	"./doubts.svg": 376,
	"./down-arrow.png": 407,
	"./down-arrow.svg": 51,
	"./dpp.svg": 1039,
	"./edit.svg": 24,
	"./editicon.png": 147,
	"./edulyst-banner.png": 444,
	"./email.png": 536,
	"./eraser.svg": 445,
	"./evaluation.svg": 245,
	"./events-icon.png": 1040,
	"./exam.svg": 1041,
	"./expand.svg": 139,
	"./faculty.svg": 1042,
	"./favicon.svg": 151,
	"./feedback-icon.svg": 534,
	"./file-download-icon.png": 169,
	"./file-icon.png": 318,
	"./full-screen.svg": 152,
	"./go-back.svg": 387,
	"./google-play.png": 256,
	"./gradingflag.png": 206,
	"./grid.svg": 47,
	"./hide.svg": 58,
	"./iconfinder_Tick_Mark_Circle_1398913.png": 183,
	"./idea.svg": 99,
	"./ideaspace.png": 1043,
	"./insertrow-icon.png": 156,
	"./insertwidget-icon.png": 157,
	"./instagram-icon.png": 317,
	"./intractive.png": 1044,
	"./invite-w.svg": 138,
	"./invite.svg": 129,
	"./learning.svg": 557,
	"./left-tray.svg": 73,
	"./left.svg": 446,
	"./link.png": 236,
	"./linkedin-icon.png": 316,
	"./list.svg": 46,
	"./listing.svg": 63,
	"./live.svg": 300,
	"./loader.png": 36,
	"./lock-icon.svg": 1045,
	"./lock-small-icon.svg": 380,
	"./logo.svg": 1046,
	"./logout.svg": 1047,
	"./loop.png": 495,
	"./map-icon.svg": 161,
	"./mapStudents.png": 408,
	"./maxresdefault.png": 225,
	"./menu.svg": 447,
	"./month.svg": 160,
	"./more.png": 211,
	"./more.svg": 496,
	"./move-left.svg": 81,
	"./move-right.svg": 82,
	"./mycoach-academy-icon.png": 189,
	"./mycoach-arrow-icon.png": 80,
	"./mycoach-ask-icon.png": 228,
	"./mycoach-backarrow.png": 1048,
	"./mycoach-backarrow.svg": 42,
	"./mycoach-fun1.png": 1049,
	"./mycoach-fun2.png": 397,
	"./mycoach-fun3.png": 1050,
	"./mycoach-goal-icon.png": 303,
	"./mycoach-icon1.png": 233,
	"./mycoach-icon2.png": 1051,
	"./mycoach-icon3.png": 1052,
	"./mycoach-icon4.png": 1053,
	"./mycoach-icon5.png": 1054,
	"./mycoach-icon6.png": 1055,
	"./mycoach-icon7.png": 1056,
	"./mycoach-icon8.png": 1057,
	"./mycoach-subscribed-icon.png": 166,
	"./nav-coursesicon.png": 1058,
	"./nav-eventsicon.png": 558,
	"./nav-ideaspaceicon.png": 559,
	"./nav-queryicon.png": 560,
	"./nav-stationaryicon.png": 1059,
	"./nav-webinaricon.png": 561,
	"./next.svg": 115,
	"./no_courses.jpg": 153,
	"./no_image.png": 1060,
	"./notes.svg": 76,
	"./notification.svg": 366,
	"./oops.png": 1061,
	"./optedout-icon-imaginxp.png": 1062,
	"./optedout-icon.png": 448,
	"./organization.svg": 1063,
	"./paid_course_csk.png": 333,
	"./paid_course_csknew.png": 252,
	"./password.svg": 207,
	"./path-b.svg": 39,
	"./path-d.svg": 38,
	"./phonecall.png": 538,
	"./pin.svg": 103,
	"./planner.svg": 1064,
	"./play.svg": 1065,
	"./plusicon.png": 516,
	"./portfolio.png": 329,
	"./portfolioimagesidebar.png": 433,
	"./power-button-svgrepo-com.svg": 431,
	"./practice.svg": 313,
	"./practise.svg": 235,
	"./prev.svg": 1066,
	"./preview-eye-icon.png": 170,
	"./preview_attempts.svg": 241,
	"./preview_difficulty.svg": 240,
	"./preview_marking.svg": 194,
	"./preview_sections.svg": 239,
	"./preview_time.svg": 193,
	"./profile-icon.png": 125,
	"./profile.svg": 75,
	"./programs.svg": 1067,
	"./qna.svg": 449,
	"./query-icon.png": 1068,
	"./question.svg": 1069,
	"./questionnaire-icon.svg": 535,
	"./random.svg": 377,
	"./refer.png": 530,
	"./refresh.png": 385,
	"./remove.svg": 399,
	"./resend.svg": 319,
	"./right-arrow-black.svg": 104,
	"./right-chevron.png": 237,
	"./right-tray.svg": 74,
	"./right.svg": 450,
	"./schoolsonweb-logo-only.png": 226,
	"./score.svg": 123,
	"./search-chapter-icon.png": 1070,
	"./search-icon-new.png": 562,
	"./search-icon.png": 1071,
	"./search-notes-icon.png": 521,
	"./search-pratice-icon.png": 1072,
	"./search-subtopic-icon.png": 1073,
	"./search-topic-icon.png": 1074,
	"./search-unit-icon.png": 1075,
	"./search-video-icon.png": 1076,
	"./search.svg": 254,
	"./search/chapter.svg": 1077,
	"./search/notes.svg": 1078,
	"./search/practise.svg": 1079,
	"./search/subtopic.svg": 1080,
	"./search/topic.svg": 1081,
	"./search/unit.svg": 1082,
	"./search/video.svg": 1083,
	"./see.svg": 54,
	"./sessions.svg": 259,
	"./setting.svg": 306,
	"./settings.svg": 563,
	"./share-icon.png": 515,
	"./sidebarmenuliveproject.png": 435,
	"./sidebarnoticeboard.png": 432,
	"./skip-fw.svg": 386,
	"./sm-assess.svg": 146,
	"./stamp.svg": 110,
	"./student.svg": 1084,
	"./studio-project-icon.png": 190,
	"./submission.svg": 234,
	"./subtopic.svg": 367,
	"./success.svg": 269,
	"./sushantu.jpeg": 537,
	"./switch.svg": 551,
	"./target.svg": 87,
	"./technology-categoryicon.png": 517,
	"./test-prep.svg": 564,
	"./tests.svg": 260,
	"./thanksdialog-checkmark.png": 93,
	"./topic.svg": 532,
	"./trainficient-logo.png": 1085,
	"./trainficient_white.png": 1086,
	"./training.png": 442,
	"./trash.svg": 35,
	"./uni_thumb.png": 327,
	"./unit.svg": 533,
	"./units-right-arrow.png": 508,
	"./universitysidebar.png": 434,
	"./up-arrow.png": 406,
	"./user-profile.svg": 91,
	"./user.svg": 1087,
	"./usermobile-icon.png": 1088,
	"./username-icon.png": 1089,
	"./userpassword-icon.png": 1090,
	"./utility.svg": 1091,
	"./video.svg": 77,
	"./web.svg": 238,
	"./webinars-icon.png": 1092,
	"./weblink.svg": 301,
	"./white-pencil.svg": 255,
	"./workshop-icon.png": 1093,
	"./www.svg": 1094,
	"./xpsidebar-challenges-icon.png": 307,
	"./xpsidebar-events-icon.png": 308,
	"./xpsidebar-ideasspace-icon.png": 565,
	"./xpsidebar-liveprojects-icon.png": 371,
	"./xpsidebar-mycoach-icon.png": 309,
	"./xpsidebar-mypercentage-icon.png": 310,
	"./xpsidebar-query-icon.png": 311,
	"./xpsidebar-stationaryshop-icon.png": 372,
	"./xpsidebar-tv-icon.png": 373,
	"./zoom-in.svg": 192,
	"./zoom.svg": 1095,
	"./zoom1.svg": 1096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1022;